import { StyledProps } from '@front10';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import React, { useContext } from 'react';
import Box from '../../../elements/Box';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';

const styles = {
  header: {
    main: {
      padding: '20px',
    },
    headerTitle: {
      height: '40px',
      marginBottom: '8px',
    },
  },
  filters: {
    main: {
      marginTop: '12px',
      marginBottom: '8px',
    },
    item: {
      height: '40px',
    },
  },
  table: {
    marginTop: '22px',
  },
  row: {
    main: {
      marginBottom: '8px',
    },
    box: {
      padding: '22px',
    },
    title: {
      height: '30px',
      marginBottom: '16px',
    },
    subtitle: {
      height: '20px',
    },
    button: {
      height: '30px',
      float: 'right',
    },
  },
  loadMore: {
    main: {
      display: 'flex',
      justifyContent: 'center',
    },
    box: {
      width: '200px',
      height: '40px',
      marginTop: '16px',
    },
  },
} as const;

interface Props {
  showFilters: boolean;
}

function FareRow() {
  const { row } = styles;

  return (
    <Col xs={12} style={row.main}>
      <Box className="fr-skeleton-box fr-clearfix" style={row.box}>
        <Col xs={6} className="fr-skeleton-element" style={row.title} />
        <Col xs={7} className="fr-skeleton-element" style={row.subtitle} />
        <Col xs={4} className="fr-skeleton-element" style={row.button} />
      </Box>
    </Col>
  );
}

function SkeletonFareTable({ showFilters = false, ...props }: StyledProps<Props>) {
  const { header, filters, table, loadMore } = styles;
  const { theme, direction } = useContext(Context);
  const [className, style] = useStyles(props, { theme, direction });
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="skeletonFareListTwoColumns"
    >
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-box" style={header.main}>
            <Col xs={8} className="fr-skeleton-element" style={header.headerTitle} />
          </Box>
        </Col>
      </Row>
      {showFilters && (
        <Row gutters style={filters.main}>
          <Col className="fr-skeleton-element" xs={12} style={filters.item} />
        </Row>
      )}
      <Row gutters style={table}>
        <FareRow />
        <FareRow />
        <FareRow />
        <FareRow />
        <FareRow />
        <FareRow />
        <FareRow />
        <FareRow />
      </Row>
      <Row gutters style={loadMore.main}>
        <Box style={loadMore.box} className="fr-skeleton-element" />
      </Row>
    </Box>
  );
}

SkeletonFareTable.componentName = 'SkeletonFareTable';

export default SkeletonFareTable;
